import {css} from "@emotion/react";

export const signup_wizard__input_container = css({width: "90%", marginTop: "0.5em"});
